module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('p', [_vm._v("Descreva todas as atividades a serem exercidas pela Empresa. Havendo mais de uma atividade, ordene-as de acordo com a ordem de atuação, iniciando com a atividade principal.")]), _vm._v(" "), _c('draggable', {
    model: {
      value: (_vm.form.atividades),
      callback: function($$v) {
        _vm.$set(_vm.form, "atividades", $$v)
      },
      expression: "form.atividades"
    }
  }, [_c('transition-group', _vm._l((_vm.form.atividades), function(atividade, index) {
    return _c('div', {
      key: atividade + '_' + index
    }, [_c('h3', [(_vm.form.atividades.length > 1) ? _c('i', {
      staticClass: "el-icon-d-caret",
      staticStyle: {
        "cursor": "pointer"
      }
    }) : _vm._e(), _vm._v(" \n          Atividade " + _vm._s(index + 1) + "\n          "), (_vm.form.atividades.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removerAtividade(atividade)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Nome",
        "prop": 'atividades.' + index + '.nome',
        "rules": {
          required: true,
          message: 'O nome da atividade é obrigatória',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      model: {
        value: (atividade.nome),
        callback: function($$v) {
          _vm.$set(atividade, "nome", $$v)
        },
        expression: "atividade.nome"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Descrição",
        "prop": 'atividades.' + index + '.descricao',
        "rules": {
          required: true,
          message: 'A descrição da atividade é obrigatória',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      model: {
        value: (atividade.descricao),
        callback: function($$v) {
          _vm.$set(atividade, "descricao", $$v)
        },
        expression: "atividade.descricao"
      }
    })], 1)], 1)
  }), 0)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.adicionarAtividade
    }
  }, [_vm._v("Adicionar Atividade")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21190a71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/AtividadesSerExercida.vue
// module id = 197
// module chunks = 1